module.exports = __webpack_public_path__ + "img/portrait-029.a561c6fe.jpg";